import { BASE_URL } from './../../api/config';
const getImageLink = ({ id, shareToken }: { id: number, shareToken?: string }) => {
    return `${BASE_URL}api/clients/logoImage/${id}${shareToken ? `?shareToken=${encodeURIComponent(shareToken)}` : ''}`;
};

export default getImageLink;